<template>
    <div>
        <ISO v-if="op_type == `iso`" ref="iso" :o_data="o_data" :c_type="c_type" :show_info="show_info"/>
        <LEG v-else-if="op_type == `leg`" ref="leg" :o_data="o_data" :c_type="c_type" :show_info="show_info"/>
        <LAT v-else-if="op_type == `lat`" ref="lat" :o_data="o_data" :c_type="c_type" :show_info="show_info"/>
        <div v-else></div>
    </div>
</template>
<script>
import ISO from "./IsoCustomData"
import LEG from "./LegCustomData"
import LAT from "./LatCustomData"
export default {
    components: {ISO, LEG, LAT}, //, AwiCustomData },
    props: ["op_type", "o_data", "c_type", "show_info"],
    data() {
        return {
        }
    },
    methods: {
        getData() {
            if (!this.$refs[this.op_type]) return {}
            return this.$refs[this.op_type].getData();
        },
        isValid() {
            if (this.$refs[this.op_type]) {
                return this.$refs[this.op_type].isValid(this.c_type)
            }
            return true
        }
    },
}
</script>

<style>
</style>